// extracted by mini-css-extract-plugin
export default {"wrapper":"fz-z","viewport":"gz-z","container":"hz-z","slide":"iz-z"};